export default __webpack_public_path__ + "static/media/miguel-lopes-10.174bf56e.jpg";